import { useTranslation } from 'next-i18next';
import styled, { DefaultTheme, ThemeContext } from 'styled-components';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { useContext } from 'react';
import Button from '../../../../new-components/ui/Button';
import { useRouter } from 'next/router';
import { resetFilters } from '../../../../helpers/search-filters';
import { SearchFiltersActionTypes } from '../../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';

const ResetFilters = () => {
  const { t } = useTranslation('common');
  const { searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const theme = useContext(ThemeContext) as DefaultTheme;
  const router = useRouter();

  const handleResetFilters = () => {
    if (router.asPath.includes('/compound')) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.RESET
      });

      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.CATEGORY,
          value: 'property'
        }
      });
    } else {
      resetFilters(router, searchFiltersDispatch);
    }
  };

  return (
    <MainContainer>
      <span>{t('no_results_to_show')}</span>
      <Button
        backgroundColor={theme.light.colors.primaryBlue}
        backgroundHover={theme.light.hoverColors.primaryBlue}
        border="none"
        color={theme.light.colors.white}
        fontSize={theme.font.sizes.s}
        text={t('reset_filters')}
        onClick={handleResetFilters}
        padding="7px 10px"
      />
    </MainContainer>
  );
};
const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px 0px;
  background: ${props => props.theme.light.colors.whitish};
  border-radius: ${props => props.theme.borderRadius};

  span {
    font-family: materialBold;
    font-size: ${props => props.theme.font.sizes.l};
    color: ${props => props.theme.light.colors.black};
  }
`;
export default ResetFilters;
